import createBaseService from "@/api/base-service.ts";
import type { HelpTopic } from "../../types/help-topic";

const helpTopicService = {
	...createBaseService<HelpTopic>("/help-topics"),
};

export default helpTopicService;
